var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"device-card-kpi"},[_c('span',{staticClass:"device-kpi-title"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"device-kpi-value"},[(_setup.isFirstLoad)?_c('b-skeleton',{attrs:{"width":"15%"}}):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }